(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const body = document.body;
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const cur = () => (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  const withW = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
  const lockImages = () => { if (body.classList.contains('protect')) $$('img').forEach((i) => (i.draggable = false)); };

  /* ---------- drawers ---------- */
  const positionBar = () => {
    const bar = $('[data-tabs-bar]'), t = $('.tab.is-active');
    if (bar && t) { bar.style.width = t.offsetWidth + 'px'; bar.style.transform = `translateX(${t.offsetLeft}px)`; }
  };
  const lockScroll = () => {
    const gap = innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--sbw', Math.max(0, gap) + 'px');
    body.classList.add('no-scroll');
  };
  const open = (name) => {
    const d = $(`[data-drawer="${name}"]`);
    if (!d) return;
    if (name === 'menu') positionBar();            /* measure while still hidden, not mid-animation */
    lockScroll();
    $('[data-overlay]').classList.add('is-open');
    requestAnimationFrame(() => d.classList.add('is-open'));   /* start the slide on a clean frame */
    if (name === 'wishlist') renderWish();
    if (name === 'search') {
      const i = $('[data-search-input]');
      if (i) { i.focus({ preventScroll: true }); setTimeout(() => i.focus({ preventScroll: true }), 350); }
    }
  };
  const closeAll = (keep) => {
    $$('[data-drawer].is-open').forEach((d) => d.classList.remove('is-open'));
    if (keep) return;
    $('[data-overlay]')?.classList.remove('is-open');
    body.classList.remove('no-scroll');
    document.documentElement.style.removeProperty('--sbw');
  };

  /* ---------- cart ---------- */
  const renderCart = async () => {
    if (body.classList.contains('template-cart')) return location.reload();
    const [s, c] = await Promise.all([fetch('/?sections=cart-drawer').then((r) => r.json()), fetch('/cart.js').then((r) => r.json())]);
    const doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-inner]', doc), now = $('[data-cart-inner]');
    if (fresh && now) now.innerHTML = fresh.innerHTML;
    $$('[data-cart-count]').forEach((n) => { n.textContent = c.item_count; n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump'); });
    lockImages();
  };
  const change = async (line, quantity) => {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    renderCart();
  };

  /* ---------- wishlist (saved in this browser) ---------- */
  const WK = 'astro_wishlist';
  const getW = () => { try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return []; } };
  const syncWish = () => {
    const w = getW();
    $$('[data-wish]').forEach((b) => { const on = w.includes(b.dataset.wish); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    $$('[data-wish-count]').forEach((n) => { n.textContent = w.length; n.hidden = !w.length; });
    $$('[data-wish-num]').forEach((n) => (n.textContent = w.length));
  };
  const setW = (a) => { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} syncWish(); };
  const renderWish = async () => {
    const box = $('[data-wish-list]');
    if (!box) return;
    const w = getW();
    if (!w.length) { box.innerHTML = `<div class="stack"><p>${esc(box.dataset.emptyTitle || 'your wishlist is empty')}</p><p class="muted">${esc(box.dataset.emptyText || '')}</p></div>`; return; }
    box.innerHTML = '<p class="muted">loading…</p>';
    const res = await Promise.all(w.map((h) => fetch('/products/' + encodeURIComponent(h) + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)));
    const items = res.filter(Boolean);
    if (items.length !== w.length) { setW(items.map((p) => p.handle)); if (!items.length) return renderWish(); }
    box.innerHTML = items.map((p) => `<div class="line"><a class="line__img" href="${esc(p.url)}">${p.featured_image ? `<img src="${esc(withW(p.featured_image, 300))}" alt="${esc(p.title)}" loading="lazy">` : ''}</a><div><a class="line__title" href="${esc(p.url)}">${esc(p.title)}</a><p class="muted">${(p.price / 100).toFixed(2)} <span class="cur">${esc(cur().toUpperCase())}</span></p></div><div class="line__right"><button type="button" class="muted" data-wish-remove="${esc(p.handle)}">${esc(box.dataset.remove || 'remove')}</button></div></div>`).join('');
    lockImages();
  };

  /* ---------- live search ---------- */
  const sIn = $('[data-search-input]'), sRes = $('[data-search-results]'), sMsg = $('[data-search-msg]'), sAll = $('[data-search-all]');
  let sTimer, sCtl;
  const runSearch = async (q) => {
    if (sCtl) sCtl.abort();
    if (q.length < 2) { sRes.innerHTML = ''; sAll.hidden = true; sMsg.hidden = false; sMsg.textContent = sMsg.dataset.hint || 'start typing to find products.'; return; }
    sCtl = new AbortController();
    try {
      const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`, { signal: sCtl.signal });
      const j = await r.json();
      const list = (j.resources && j.resources.results && j.resources.results.products) || [];
      if (!list.length) { sRes.innerHTML = ''; sAll.hidden = true; sMsg.hidden = false; sMsg.textContent = `no results for “${q}”.`; return; }
      sMsg.hidden = true;
      sRes.innerHTML = list.map((p, i) => `<a class="sr__item" style="--i:${i}" href="${esc(p.url)}"><span class="sr__img">${p.image ? `<img src="${esc(withW(p.image, 400))}" alt="${esc(p.title)}" loading="lazy">` : ''}</span><span class="sr__name">${esc(p.title)}</span><span class="sr__price muted">${esc(p.price)} <span class="cur">${esc(cur().toUpperCase())}</span></span></a>`).join('');
      sAll.href = `/search?q=${encodeURIComponent(q)}&type=product`;
      sAll.hidden = false;
      lockImages();
    } catch (e) { /* aborted */ }
  };
  if (sIn) sIn.addEventListener('input', () => { clearTimeout(sTimer); sTimer = setTimeout(() => runSearch(sIn.value.trim()), 220); });

  /* ---------- global events ---------- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); closeAll(true); open(o.dataset.drawerOpen); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) { closeAll(); return; }

    const tab = e.target.closest('[data-tab]');
    if (tab) {
      const id = tab.dataset.tab;
      $$('[data-tab]').forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
      $$('[data-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.panel === id));
      positionBar();
      return;
    }
    const acc = e.target.closest('[data-acc]');
    if (acc) {
      const li = acc.closest('.has-sub'), willOpen = !li.classList.contains('is-open');
      [...li.parentElement.children].forEach((sib) => { if (sib !== li && sib.classList.contains('has-sub')) { sib.classList.remove('is-open'); $('[data-acc]', sib)?.setAttribute('aria-expanded', 'false'); } });
      li.classList.toggle('is-open', willOpen);
      acc.setAttribute('aria-expanded', willOpen);
      return;
    }
    const wish = e.target.closest('[data-wish]');
    if (wish) {
      e.preventDefault();
      const h = wish.dataset.wish, w = getW();
      setW(w.includes(h) ? w.filter((x) => x !== h) : [...w, h]);
      return;
    }
    const wr = e.target.closest('[data-wish-remove]');
    if (wr) { setW(getW().filter((x) => x !== wr.dataset.wishRemove)); renderWish(); return; }

    const q = e.target.closest('[data-qty]');
    if (q) { e.preventDefault(); change(+q.dataset.line, +q.dataset.qty); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('change', (e) => { const el = e.target.closest('[data-auto-submit]'); if (el) (el.form || el).submit(); });
  addEventListener('resize', positionBar);
  syncWish();
  document.addEventListener('astro:content', () => { syncWish(); lockImages(); });

  /* ---------- add to cart / buy now ---------- */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-product-form]');
    if (!f) return;
    e.preventDefault();
    if (f.dataset.busy) return;
    const buyNow = !!(e.submitter && e.submitter.name === 'checkout');
    const btns = $$('[data-add]', f), err = $('[data-error]', f);
    f.dataset.busy = '1';
    btns.forEach((b) => (b.disabled = true)); if (err) err.textContent = '';
    try {
      const fd = new FormData(f); fd.delete('checkout'); fd.delete('add');
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || 'could not add to cart');
      if (buyNow) { location.assign('/checkout'); return; } // keep buttons locked while redirecting
      await renderCart();
      closeAll(); open('cart');
    } catch (x) { if (err) err.textContent = x.message; }
    delete f.dataset.busy;
    btns.forEach((b) => (b.disabled = false));
  });

  /* ---------- header ---------- */
  const h = $('[data-header]');
  if (h) {
    let last = scrollY, ticking = false;
    const sizeHeader = () => {
      document.documentElement.style.setProperty('--header-h', (h.offsetHeight + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ann-top')) || 0)) + 'px');
    };
    const set = () => {
      ticking = false;
      const y = scrollY;
      h.classList.toggle('is-scrolled', y > 20);
      if (h.hasAttribute('data-autohide') && !body.classList.contains('no-scroll')) {
        const d = y - last;
        if (y > 160 && d > 6) h.classList.add('is-hidden'); else if (d < -6 || y < 160) h.classList.remove('is-hidden');
      }
      last = y;
    };
    sizeHeader(); set();
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(set); } }, { passive: true });
    addEventListener('resize', () => { sizeHeader(); set(); });
  }

  /* ---------- product page ---------- */
  const g = $('[data-gallery]'), prog = $('[data-prog]'), count = $('[data-count]');
  if (g && prog) {
    const dots = [...prog.children];
    const upd = () => {
      const i = Math.min(dots.length - 1, Math.max(0, Math.round(g.scrollLeft / (g.clientWidth || 1))));
      dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      if (count) count.textContent = `${i + 1}/${dots.length}`;
    };
    g.addEventListener('scroll', upd, { passive: true });
    upd();
  }
  /* sticky add-to-cart bar: only after the main button has been scrolled UP past the top of the
     screen (never while the button is still below, e.g. when landing from a Facebook ad) */
  const sticky = $('[data-sticky]'), actions = $('[data-actions]');
  if (sticky && !actions) sticky.classList.add('is-on');
  if (sticky && actions) {
    const passed = () => actions.getBoundingClientRect().bottom <= 0;
    const upd = () => sticky.classList.toggle('is-on', passed());
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.bottom <= 0), { threshold: 0 }).observe(actions);
    } else {
      addEventListener('scroll', upd, { passive: true });
      addEventListener('resize', upd);
      upd();
    }
  }
  const pf = $('[data-product-form]'), vj = $('[data-variants]');
  if (pf && vj) {
    const variants = JSON.parse(vj.textContent);
    const markSold = () => {
      const fs = $$('[data-option]', pf);
      const chosen = fs.map((x) => ($('input:checked', x) || {}).value);
      fs.forEach((x, i) => $$('input', x).forEach((inp) => {
        const ok = variants.some((v) => v.a && v.o[i] === inp.value && v.o.every((val, k) => k === i || val === chosen[k]));
        const lab = inp.nextElementSibling;
        if (lab) { lab.classList.toggle('is-sold', !ok); lab.title = ok ? (lab.title || '') : 'sold out'; }
      }));
    };
    const stockMsg = (v) => {
      const el = $('[data-stock]', pf);
      if (!el) return;
      const low = +el.dataset.low || 0;
      let msg = '';
      if (!v.a) msg = el.dataset.sold || '';
      else if (low > 0 && v.q > 0 && v.q <= low) msg = (el.dataset.tpl || 'only {n} left').replace('{n}', v.q);
      el.textContent = msg; el.hidden = !msg; el.classList.toggle('is-low', !!v.a && !!msg);
    };
    const update = () => {
      const fs = $$('[data-option]', pf);
      fs.forEach((x) => { const c = $('input:checked', x), n = $('[data-opt-name]', x); if (c && n) n.textContent = c.value; });
      const chosen = fs.map((x) => ($('input:checked', x) || {}).value);
      const v = variants.find((x) => x.o.every((val, i) => val === chosen[i]));
      const btns = $$('[data-add]', pf), labels = $$('[data-btn-label]', pf);
      markSold();
      if (!v) { btns.forEach((b) => (b.disabled = true)); labels.forEach((l) => (l.textContent = l.dataset.na || 'unavailable')); return; }
      stockMsg(v);
      $('[data-variant-id]', pf).value = v.id;
      $$('[data-price]').forEach((n) => (n.innerHTML = v.p));
      const so = $('[data-sticky-opts]'); if (so) so.textContent = chosen.join(' / ');
      const si = $('[data-sticky-img]'), src = v.m && $(`[data-media-id="${v.m}"] img`);
      if (si && src && (src.currentSrc || src.src)) si.src = src.currentSrc || src.src;
      const cmp = $('[data-compare]');
      if (cmp) { cmp.innerHTML = v.c; cmp.hidden = !v.c; }
      const bd = $('[data-badge]');
      if (bd) { bd.textContent = v.b; bd.hidden = !v.b; }
      btns.forEach((b) => (b.disabled = !v.a));
      labels.forEach((l) => (l.textContent = v.a ? (l.dataset.add || 'add to cart') : (l.dataset.sold || 'sold out')));
      history.replaceState(null, '', '?variant=' + v.id);
      const fig = v.m && $(`[data-media-id="${v.m}"]`);
      if (g && fig && g.scrollWidth > g.clientWidth) g.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
    };
    pf.addEventListener('change', (e) => {
      const fx = e.target.closest('[data-option]');
      if (!fx) return;
      const fs = $$('[data-option]', pf), i = fs.indexOf(fx);
      if (fs.length > 1) { // if the new combination is sold out, jump to the nearest available one
        const chosen = fs.map((x) => ($('input:checked', x) || {}).value);
        const cur = variants.find((x) => x.o.every((val, k) => val === chosen[k]));
        if (!cur || !cur.a) {
          const alt = variants.find((x) => x.a && x.o[i] === chosen[i]);
          if (alt) fs.forEach((x, k) => { if (k !== i) { const inp = $$('input', x).find((n) => n.value === alt.o[k]); if (inp) inp.checked = true; } });
        }
      }
      update();
    });
    markSold();
    const v0 = variants.find((x) => String(x.id) === ($('[data-variant-id]', pf) || {}).value);
    if (v0) stockMsg(v0);
  }

  /* ---------- recommendations ---------- */
  const reco = $('[data-reco]');
  if (reco && !reco.children.length && reco.dataset.url) {
    fetch(reco.dataset.url).then((r) => r.text()).then((t) => {
      const el = $('[data-reco]', new DOMParser().parseFromString(t, 'text/html'));
      if (el && el.children.length) { reco.innerHTML = el.innerHTML; const w = reco.closest('[hidden]'); if (w) w.hidden = false; lockImages(); syncWish(); }
    }).catch(() => {});
  }

  /* ---------- slideshow ---------- */
  $$('[data-slides]').forEach((el) => {
    const tr = $('[data-slides-track]', el), dots = $$('[data-dot]', el), n = tr.children.length;
    let i = 0, timer;
    const go = (k) => { i = (k + n) % n; tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); };
    tr.addEventListener('scroll', () => { i = Math.round(tr.scrollLeft / tr.clientWidth); dots.forEach((d, x) => d.classList.toggle('is-on', x === i)); }, { passive: true });
    dots.forEach((d, x) => d.addEventListener('click', () => go(x)));
    $$('[data-slide-nav]', el).forEach((b) => b.addEventListener('click', () => go(i + (+b.dataset.slideNav))));
    const ms = (+el.dataset.auto || 0) * 1000;
    if (ms && n > 1 && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
      const stop = () => clearInterval(timer), start = () => { stop(); timer = setInterval(() => go(i + 1), ms); };
      start(); el.addEventListener('pointerenter', stop); el.addEventListener('pointerleave', start); el.addEventListener('touchstart', stop, { passive: true });
    }
  });

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach((el) => {
    const end = new Date((el.dataset.countdown || '').trim().replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    const set = (k, v) => { const n = $(`[data-cd="${k}"]`, el); if (n) n.textContent = String(v).padStart(2, '0'); };
    let iv;
    const tick = () => {
      const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      set('d', Math.floor(s / 86400)); set('h', Math.floor((s % 86400) / 3600)); set('m', Math.floor((s % 3600) / 60)); set('s', s % 60);
      if (s === 0) { el.classList.add('is-done'); clearInterval(iv); }
    };
    tick(); iv = setInterval(tick, 1000);
  });

  /* ---------- copy code / hotspots / tabs ---------- */
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-copy]');
    if (c) {
      const txt = c.dataset.copy;
      const fallback = () => { const ta = document.createElement('textarea'); ta.value = txt; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (_) {} ta.remove(); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).catch(fallback); else fallback();
      const l = $('[data-copy-label]', c);
      if (l) { const o = l.dataset.orig || l.textContent; l.dataset.orig = o; l.textContent = c.dataset.done || 'copied'; setTimeout(() => (l.textContent = o), 1800); }
    }
    const h = e.target.closest('[data-hs]');
    $$('.hs.is-open').forEach((x) => { if (!h || x !== h.closest('.hs')) x.classList.remove('is-open'); });
    if (h) h.closest('.hs').classList.toggle('is-open');
    const tb = e.target.closest('[data-tab]');
    if (tb) {
      const w = tb.closest('[data-tabs]');
      $$('[data-tab]', w).forEach((x) => { const on = x === tb; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
      $$('[data-panel]', w).forEach((p) => (p.hidden = p.dataset.panel !== tb.dataset.tab));
    }
  });

  /* ---------- carousel arrows ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-car-nav]');
    if (!b) return;
    const tr = $('[data-car-track]', b.closest('[data-carousel]'));
    if (tr) tr.scrollBy({ left: (+b.dataset.carNav) * tr.clientWidth * 0.85, behavior: 'smooth' });
  });

  /* ---------- scroll reveal ---------- */
  const revealAll = () => $$('.rv').forEach((n) => n.classList.add('is-in'));
  if (document.documentElement.classList.contains('js') && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    $$('.rv').forEach((n) => io.observe(n));
    setTimeout(revealAll, 4000);
  } else revealAll();
  document.addEventListener('shopify:section:load', revealAll);

  /* ---------- image protection ---------- */
  if (body.classList.contains('protect')) {
    const media = 'img,picture,video,.card__media,.pdp__img,.line__img,.sr__img,.hero,.opt__thumb';
    document.addEventListener('contextmenu', (e) => { if (e.target.closest && e.target.closest(media)) e.preventDefault(); });
    document.addEventListener('dragstart', (e) => { if (e.target.closest && e.target.closest(media)) e.preventDefault(); });
    lockImages();
    new MutationObserver(lockImages).observe(body, { childList: true, subtree: true });
  }
})();

/* =====================================================================
   v9 · premium layer
   ===================================================================== */
(() => {
  const $ = (q, c = document) => c.querySelector(q);
  const $$ = (q, c = document) => [...c.querySelectorAll(q)];
  const root = document.documentElement, body = document.body;
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const jsOn = root.classList.contains('js');

  /* ---------- announcement bar: sticky top / bottom ---------- */
  /* Works on every browser / in-app webview (Facebook, Instagram, TikTok, Safari, Chrome, Samsung...):
     - class fallback for browsers without :has()
     - bottom offset corrected against the real visible viewport
     - bogus safe-area insets (Android webviews) are ignored, see --sab in theme.css */
  const annSync = () => {
    const a = $('[data-ann]'), wrap = a && a.parentElement, pos = a ? a.dataset.pos : 'static';
    if (wrap) {
      wrap.classList.add('ann-wrap');
      wrap.classList.toggle('ann-wrap--bottom', pos === 'sticky_bottom');
      wrap.classList.toggle('ann-wrap--top', pos === 'sticky_top');
    }
    const h = wrap ? wrap.offsetHeight : 0;
    root.style.setProperty('--ann-top', pos === 'sticky_top' ? h + 'px' : '0px');
    root.style.setProperty('--ann-bottom', pos === 'sticky_bottom' ? h + 'px' : '0px');
    body.classList.toggle('has-ann-bottom', pos === 'sticky_bottom');
    const hd = $('[data-header]');
    if (hd) root.style.setProperty('--header-h', (hd.offsetHeight + (pos === 'sticky_top' ? h : 0)) + 'px');
  };
  annSync();
  addEventListener('resize', annSync);
  addEventListener('orientationchange', annSync);
  addEventListener('load', annSync);
  addEventListener('pageshow', annSync);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(annSync);
  if ('ResizeObserver' in window) { const a = $('[data-ann]'); if (a) new ResizeObserver(annSync).observe(a.parentElement); }

  /* ---------- collection filters (price slider, color palette) ---------- */
  let filtersBound = false;
  const initFilters = () => {
    const form = $('[data-filter-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    const pr = $('[data-price-range]', form);
    let rLo, rHi, nLo, nHi, max = 0;
    const paint = () => { if (pr) { pr.style.setProperty('--lo', rLo.value); pr.style.setProperty('--hi', rHi.value); } };
    let timer, ctl;
    const queue = () => { clearTimeout(timer); timer = setTimeout(() => apply(), 380); };
    const buildUrl = () => {
      const p = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') p.append(k, v); });
      const q = p.toString();
      return form.getAttribute('action').split('?')[0] + (q ? '?' + q : '');
    };
    const syncFromUrl = (u) => {
      const p = new URL(u, location.origin).searchParams;
      $$('input[type=checkbox]', form).forEach((i) => { i.checked = p.getAll(i.name).includes(i.value); });
      if (pr) {
        const lo = p.get(nLo.name), hi = p.get(nHi.name);
        nLo.value = lo || ''; nHi.value = hi || ''; rLo.value = lo || 0; rHi.value = hi || max; paint();
      }
    };
    const apply = async (url, push = true) => {
      url = url || buildUrl();
      const res = $('[data-collection-results]');
      if (!res) { location.assign(url); return; }
      if (ctl) ctl.abort();
      ctl = new AbortController();
      res.classList.add('is-loading');
      try {
        const r = await fetch(url, { signal: ctl.signal });
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const nr = $('[data-collection-results]', doc);
        if (!nr) throw new Error('no results');
        res.innerHTML = nr.innerHTML;
        const nc = $('[data-fcount]', doc);
        if (nc) $$('[data-fcount]').forEach((n) => (n.textContent = nc.textContent));
        const nb = $('[data-fbadge]', doc), ob = $('[data-fbadge]');
        if (ob && nb) { ob.textContent = nb.textContent; ob.hidden = nb.hidden; }
        $$('input[type=checkbox]', form).forEach((inp) => {
          const m = $(`input[name="${CSS.escape(inp.name)}"][value="${CSS.escape(inp.value)}"]`, doc);
          if (m) { inp.disabled = m.disabled; const w = inp.closest('.sw,.fpill'); if (w) w.classList.toggle('is-off', m.disabled); }
        });
        if (push) history.pushState({ f: 1 }, '', url);
        document.dispatchEvent(new Event('astro:content'));
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        location.assign(url); return;
      }
      res.classList.remove('is-loading');
    };
    if (pr) {
      max = +pr.dataset.max;
      rLo = $('[data-pr-r="lo"]', pr); rHi = $('[data-pr-r="hi"]', pr);
      nLo = $('[data-pr-in="lo"]', pr); nHi = $('[data-pr-in="hi"]', pr);
      const fromRange = (which) => {
        let lo = +rLo.value, hi = +rHi.value;
        if (lo > hi) { if (which === 'lo') { lo = hi; rLo.value = lo; } else { hi = lo; rHi.value = hi; } }
        nLo.value = lo > 0 ? lo : ''; nHi.value = hi < max ? hi : ''; paint();
      };
      rLo.addEventListener('input', () => { fromRange('lo'); queue(); });
      rHi.addEventListener('input', () => { fromRange('hi'); queue(); });
      const fromNum = () => {
        const lo = Math.max(0, Math.min(max, +nLo.value || 0));
        const hi = nHi.value === '' ? max : Math.max(lo, Math.min(max, +nHi.value));
        rLo.value = lo; rHi.value = hi; paint(); queue();
      };
      nLo.addEventListener('change', fromNum); nHi.addEventListener('change', fromNum);
      if (nLo.value === '') rLo.value = 0;
      if (nHi.value === '') rHi.value = max;
      paint();
    }
    form.addEventListener('change', (e) => { if (e.target.matches('input[type=checkbox]')) queue(); });
    form.addEventListener('submit', (e) => {
      e.preventDefault(); clearTimeout(timer); apply();
      const c = $('[data-drawer="filters"] [data-drawer-close]'); if (c) c.click();
    });
    if (!filtersBound) {
      filtersBound = true;
      document.addEventListener('click', (e) => {
        const a = e.target.closest('[data-fremove]');
        if (!a || !$('[data-filter-form]')) return;
        e.preventDefault(); syncFromUrl(a.href); apply(a.href);
      });
      addEventListener('popstate', () => { if ($('[data-filter-form]')) { syncFromUrl(location.href); apply(location.href, false); } });
    }
  };

  /* ---------- parallax (reads batched, writes only when changed) ---------- */
  let par = [], parTick = false, hdrH = 0;
  const readHdr = () => { hdrH = parseFloat(getComputedStyle(root).getPropertyValue('--header-h')) || 0; };
  const parCollect = () => { par = $$('[data-parallax]').map((el) => ({ el, k: +el.dataset.parallax || 0.15, host: el.parentElement, v: '' })); };
  const parRun = () => {
    parTick = false;
    if (!par.length) return;
    const vh = innerHeight;
    const rects = par.map((p) => p.host.getBoundingClientRect());
    par.forEach((p, i) => {
      const r = rects[i];
      if (r.bottom < -120 || r.top > vh + 120) return;
      const lim = r.height * 0.075;
      const v = Math.max(-lim, Math.min(lim, -(r.top + r.height / 2 - vh / 2) * p.k)).toFixed(1) + 'px';
      if (v !== p.v) { p.v = v; p.el.style.setProperty('--py', v); }
    });
  };

  /* ---------- scroll text reveal (only visible blocks, only changed words) ---------- */
  let trs = [];
  const trCollect = () => { trs = $$('[data-tr]').map((el) => ({ el, words: $$('.tr__w', el), n: -1 })); };
  const trRun = () => {
    if (!trs.length) return;
    const vh = innerHeight;
    const rects = trs.map((t) => t.el.getBoundingClientRect());
    trs.forEach((t, i) => {
      const r = rects[i];
      if (r.bottom < -200 || r.top > vh + 200) return;
      const p = Math.min(1, Math.max(0, (vh * 0.82 - r.top) / (r.height + vh * 0.32)));
      const n = Math.round(p * t.words.length * 1.04);
      if (n === t.n) return;
      const lo = Math.max(0, Math.min(n, t.n < 0 ? 0 : t.n)), hi = t.n < 0 ? t.words.length : Math.max(n, t.n);
      for (let k = lo; k < Math.min(hi, t.words.length); k++) t.words[k].classList.toggle('is-on', k < n);
      t.n = n;
    });
  };

  /* ---------- horizontal showcase (pinned) ---------- */
  let hxs = [];
  const hxLayout = () => {
    hxs = [];
    const desktop = matchMedia('(min-width:990px)').matches && !reduce && jsOn;
    $$('[data-hx][data-hx-pin]').forEach((el) => {
      const scroll = $('[data-hx-scroll]', el), pin = $('[data-hx-pin-el]', el), track = $('[data-hx-track]', el);
      if (!scroll || !pin || !track) return;
      if (!desktop) { scroll.style.height = ''; track.style.removeProperty('--hx-x'); return; }
      const dist = Math.max(0, track.scrollWidth - pin.clientWidth);
      scroll.style.height = pin.offsetHeight + dist + 'px';
      hxs.push({ el, scroll, pin, track, dist, x: '' });
    });
    readHdr();
    hxRun();
  };
  const hxRun = () => {
    if (!hxs.length) return;
    const vh = innerHeight;
    const tops = hxs.map((h) => h.scroll.getBoundingClientRect());
    hxs.forEach((h, i) => {
      const r = tops[i];
      if (r.bottom < -vh || r.top > vh * 2) return;
      const total = h.scroll.offsetHeight - h.pin.offsetHeight;
      const p = total > 0 ? Math.min(1, Math.max(0, (hdrH - r.top) / total)) : 0;
      const x = (-p * h.dist).toFixed(1) + 'px';
      if (x !== h.x) { h.x = x; h.track.style.setProperty('--hx-x', x); h.el.style.setProperty('--hx-p', p.toFixed(4)); }
    });
  };

  /* ---------- hover list: picture follows the cursor ---------- */
  const hlInit = () => {
    $$('[data-hl]').forEach((hl) => {
      if (hl.dataset.ready) return;
      hl.dataset.ready = '1';
      const prev = $('[data-hl-preview]', hl);
      if (!prev || !matchMedia('(hover:hover) and (min-width:990px)').matches) return;
      const imgs = $$('.hl__img', prev), rows = $$('[data-hl-row]', hl);
      let x = 0, y = 0, tx = 0, ty = 0, raf = 0;
      const loop = () => {
        x += (tx - x) * 0.14; y += (ty - y) * 0.14;
        prev.style.transform = `translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0)`;
        raf = (Math.abs(tx - x) > 0.4 || Math.abs(ty - y) > 0.4) ? requestAnimationFrame(loop) : 0;
      };
      hl.addEventListener('mousemove', (e) => {
        const r = hl.getBoundingClientRect();
        tx = Math.min(e.clientX - r.left + 28, r.width - prev.offsetWidth);
        ty = e.clientY - r.top - prev.offsetHeight / 2;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      rows.forEach((row) => row.addEventListener('mouseenter', () => {
        hl.classList.add('is-hover');
        rows.forEach((o) => o.classList.toggle('is-on', o === row));
        imgs.forEach((i) => i.classList.toggle('is-on', i.dataset.hlI === row.dataset.hlRow));
      }));
      hl.addEventListener('mouseleave', () => { hl.classList.remove('is-hover'); rows.forEach((o) => o.classList.remove('is-on')); });
    });
  };

  /* ---------- smooth mouse-wheel scrolling (desktop mice only; phones and trackpads stay native) ---------- */
  const smoothWheel = () => {
    if (!body.classList.contains('smooth-scroll') || reduce) return;
    if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    root.style.scrollBehavior = 'auto';
    const k = Math.min(0.4, Math.max(0.03, (+body.dataset.smooth || 10) / 100));
    let cur = scrollY, target = scrollY, anim = false, last = 0;
    const max = () => Math.max(0, root.scrollHeight - innerHeight);
    const frame = (t) => {
      const dt = Math.min(48, last ? t - last : 16.7); last = t;
      cur += (target - cur) * (1 - Math.pow(1 - k, dt / 16.7));
      if (Math.abs(target - cur) < 0.4) { cur = target; scrollTo(0, cur); anim = false; last = 0; return; }
      scrollTo(0, cur);
      requestAnimationFrame(frame);
    };
    const go = (y) => { target = Math.min(max(), Math.max(0, y)); if (!anim) { cur = scrollY; anim = true; last = 0; requestAnimationFrame(frame); } };
    const mouseWheel = (e) => e.deltaMode === 1 || (e.wheelDeltaY && e.wheelDeltaY % 120 === 0 && e.deltaX === 0);
    const innerScroller = (el, dy) => {
      for (; el && el !== body && el !== root; el = el.parentElement) {
        if (el.hasAttribute && el.hasAttribute('data-lenis-prevent')) return true;
        const cs = getComputedStyle(el);
        if (/(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 1) {
          if (dy < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1) return true;
        }
      }
      return false;
    };
    addEventListener('wheel', (e) => {
      if (e.defaultPrevented || e.ctrlKey || e.metaKey || !mouseWheel(e) || body.classList.contains('no-scroll')) return;
      if (innerScroller(e.target, e.deltaY)) return;
      e.preventDefault();
      if (!anim) { cur = target = scrollY; }
      go(target + e.deltaY * (e.deltaMode === 1 ? 32 : 1));
    }, { passive: false });
    addEventListener('scroll', () => { if (!anim) cur = target = scrollY; }, { passive: true });
    addEventListener('keydown', () => { if (anim) { anim = false; cur = target = scrollY; } });
    addEventListener('pointerdown', () => { if (anim) { anim = false; cur = target = scrollY; } });
    document.addEventListener('click', (e) => {          /* #anchor links glide with the same easing */
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2 || e.defaultPrevented) return;
      const el = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (!el) return;
      e.preventDefault();
      go(el.getBoundingClientRect().top + scrollY - hdrH);
    });
  };


  /* ---------- photo normaliser: every photo background becomes the theme's card grey ----------
     - uniform studio background (white, grey, beige)  -> brightness filter so it equals the frame colour exactly
     - gradient / busy / very dark background          -> left exactly as uploaded (never cropped or zoomed)
     - transparent PNG                                 -> left alone (already sits on the frame colour)
     No blend modes are used, so nothing is ever darkened by the browser. */
  const matchBg = () => {
    if (!body.classList.contains('match-bg')) return;
    if (matchBg.scan) { matchBg.scan(document.body); return; }
    const FRAMES = '.card__media,.pdp__img,.line__img,.sr__img,.pdp__sticky-img';
    const KEY = 'astro-imgbg-v3';
    let saved = {};
    try { saved = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { saved = {}; }
    const mem = new Map(Object.entries(saved));
    let dirty = false, tm = 0;
    const persist = () => {
      clearTimeout(tm);
      tm = setTimeout(() => {
        if (!dirty) return; dirty = false;
        try { localStorage.setItem(KEY, JSON.stringify(Object.fromEntries([...mem.entries()].slice(-600)))); } catch (e) { /* quota / private mode */ }
      }, 600);
    };
    const keyOf = (src) => { try { return new URL(src, location.href).pathname; } catch (e) { return src; } };
    const lumOf = (r, g, b) => 0.2126 * r + 0.7152 * g + 0.0722 * b;
    const frameLum = (frame) => {
      const m = (getComputedStyle(frame).backgroundColor || '').match(/[\d.]+/g);
      return m && m.length >= 3 ? lumOf(+m[0], +m[1], +m[2]) : 242;
    };
    let cv = null, cx = null;
    const N = 24;
    const classify = (im) => {
      try {
        if (!cv) { cv = document.createElement('canvas'); cv.width = cv.height = N; cx = cv.getContext('2d', { willReadFrequently: true }); }
        cx.clearRect(0, 0, N, N);
        cx.drawImage(im, 0, 0, N, N);
        const d = cx.getImageData(0, 0, N, N).data, px = [];
        const add = (x, y) => { const k = (y * N + x) * 4; px.push([d[k], d[k + 1], d[k + 2], d[k + 3]]); };
        for (let i = 0; i < N; i++) { add(i, 0); add(i, 1); add(i, N - 1); add(i, N - 2); add(0, i); add(1, i); add(N - 1, i); add(N - 2, i); }
        if (px.some((q) => q[3] < 200)) return { t: 'n' };
        const ls = px.map((q) => lumOf(q[0], q[1], q[2])).sort((a, b) => a - b);
        const med = ls[Math.floor(ls.length / 2)];
        const spread = ls[Math.floor(ls.length * 0.9)] - ls[Math.floor(ls.length * 0.1)];
        if (spread > 40) return { t: 'n' };                            /* busy / lifestyle photo: leave exactly as is */
        return { t: 's', l: Math.round(med * 10) / 10 };
      } catch (e) { return { t: 'n' }; }
    };
    const apply = (img, frame, r) => {
      if (!r || r.t !== 's') return;
      const k = frameLum(frame) / r.l;
      if (k < 0.8 || k > 1.45 || Math.abs(1 - k) < 0.015) return;   /* out of safe range: never touch the photo */
      img.style.setProperty('--k', k.toFixed(3));
      img.classList.add('bg-scale');
    };
    const probe = (frame, im) => {
      if (im.dataset.bgDone) return;
      const src = im.currentSrc || im.src || im.getAttribute('data-src');
      if (!src) return;
      im.dataset.bgDone = '1';
      const k = keyOf(src);
      if (mem.has(k)) { apply(im, frame, mem.get(k)); return; }
      let url;
      try { const u = new URL(src, location.href); u.searchParams.set('width', '48'); u.searchParams.delete('height'); u.searchParams.delete('crop'); url = u.toString(); } catch (e) { return; }
      const p = new Image();
      p.crossOrigin = 'anonymous';
      p.decoding = 'async';
      p.onload = () => { const r = classify(p); mem.set(k, r); dirty = true; persist(); apply(im, frame, r); };
      p.onerror = () => { mem.set(k, { t: 'n' }); };
      p.src = url;
    };
    const run = (frame) => frame.querySelectorAll('img').forEach((im) => probe(frame, im));
    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { io.unobserve(en.target); run(en.target); } }), { rootMargin: '700px 0px' })
      : null;
    const watch = (frame) => { if (frame.dataset.bgWatch) return; frame.dataset.bgWatch = '1'; io ? io.observe(frame) : run(frame); };
    const scan = (root) => {
      if (root.nodeType !== 1) return;
      if (root.matches && root.matches(FRAMES)) watch(root);
      root.querySelectorAll && root.querySelectorAll(FRAMES).forEach(watch);
    };
    matchBg.scan = scan;
    scan(document.body);
    if ('MutationObserver' in window) {
      new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach(scan))).observe(document.body, { childList: true, subtree: true });
    }
  };

  /* ---------- scroll loop + boot ---------- */
  const onScroll = () => {
    if (!parTick) { parTick = true; requestAnimationFrame(() => { if (!reduce) parRun(); trRun(); hxRun(); }); }
  };
  const asyncImgs = () => $$('img:not([decoding])').forEach((i) => { i.decoding = 'async'; });
  const boot = () => {
    matchBg(); initFilters(); hlInit(); parCollect(); trCollect(); readHdr(); hxLayout(); annSync(); asyncImgs();
    if (!reduce) parRun();
    trRun();
  };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', () => { readHdr(); hxLayout(); onScroll(); });
  addEventListener('load', () => { readHdr(); hxLayout(); onScroll(); });
  document.addEventListener('astro:content', asyncImgs);
  document.addEventListener('shopify:section:load', () => setTimeout(boot, 50));
  smoothWheel();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
